import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FusLocationFormatter } from '@services/location/location-formatters/fus-location-formatter/fus-location-formatter';
import { ProfileService } from '@services/profile/profile.service';
import { ILocationFormatter } from '../ILocationFormatter';
import { CnuLocationFormatter } from '../location-formatters/cnu-location-formatter/cnu-location-formatter';
import { CraiolLocationFormatter } from '../location-formatters/craiol-location-formatter/craiol-location-formatter';
import { CvpLocationFormatter } from '../location-formatters/cvp-location-formatter/cvp-location-formatter';
import { DcasLocationFormatter } from '../location-formatters/dcas-location-formatter/dcas-location-formatter';
import { DefaultLocationFormatter } from '../location-formatters/default-location-formatter';
import { MdpLocationFormatter } from '../location-formatters/mdp-location-formatter/mdp-location-formatter';
import { PcfLocationFormatter } from '../location-formatters/pcf-location-formatter/pcf-location-formatter';
import { PnLocationFormatter } from '../location-formatters/pn-location-formatter/pn-location-formatter';
import { SisLocationFormatter } from '../location-formatters/sis-location-formatter/sis-location-formatter';

@Injectable({
  providedIn: 'root'
})
export class LocationFormatterFactoryService {
  private locationFormatter: ILocationFormatter;

  constructor(private profile: ProfileService, private translate: TranslateService) {}

  getFormatter(): ILocationFormatter {
    if (!this.locationFormatter) {
      this.locationFormatter = this.createFormatter(this.profile.current.webConfig.locationFormatter);
    }

    return this.locationFormatter;
  }

  private createFormatter(formatterName: string): ILocationFormatter {
    switch (formatterName) {
      case 'craiol':
        return new CraiolLocationFormatter(this.translate);

      case 'cnu':
        return new CnuLocationFormatter(this.translate);

      case 'cvp':
        return new CvpLocationFormatter(this.translate);

      case 'dcas':
        return new DcasLocationFormatter(this.translate);

      case 'fus':
        return new FusLocationFormatter(this.translate);

      case 'mdp':
        return new MdpLocationFormatter(this.translate);

      case 'pcf':
        return new PcfLocationFormatter(this.translate);

      case 'pn':
        return new PnLocationFormatter(this.translate);

      case 'sis':
        return new SisLocationFormatter(this.translate);

      default:
        return new DefaultLocationFormatter(this.translate);
    }
  }
}
